import BasketPage from "./basket-page";

export default BasketPage;